<template>
  <div class="label-wrapper" :class="{'normal':size==='normal'}">
    <div class="label">{{ label }}</div>
    <div class="val">
      <slot>{{ value }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String | Number,
      default: ''
    },
    size: {
      type: String,
      default: 'normal'
    }
  }
}
</script>

<style lang="scss" scoped>
.label-wrapper {
  display: flex;
  font-size: 12px;
  font-weight: 500;
  align-items: center;
  height: 40px;

  .label::after {
    content: "：";
  }
}
.normal{
  font-size: 16px;
}
</style>
